import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MdbModalRef } from 'mdb-angular-ui-kit/modal';
import * as Highcharts from 'highcharts';
import { CrosstrendService } from 'src/app/services/crosstrend.service';
import { HighchartsChartModule } from 'highcharts-angular';

@Component({
  selector: 'app-modal-graph',
  standalone: true,
  imports: [CommonModule, HighchartsChartModule],
  templateUrl: './modal-graph.component.html',
  styleUrl: './modal-graph.component.scss'
})
export class ModalGraphComponent {
  tableData: any
  graphData: any
  title: string = ''
  params: any

  chartOptions: Highcharts.Options = {}
  Highcharts: typeof Highcharts = Highcharts;
  chartConstructor: string = 'chart';
  updateFlag: boolean = false; // optional boolean
  oneToOneFlag: boolean = true; // optional boolean, defaults to false
  runOutsideAngular: boolean = false; // optional boolean, defaults to false
  runOutsideAngularFlag = false; // optional boolean, defaults to false

  headers: string[] = ['Verso','CrossTrend','ora', 'prezzo', 'ora chiusura', 'prezzo', 'profit']
  constructor(public modalRef: MdbModalRef<ModalGraphComponent>,
    private serv: CrosstrendService
  ) { }

  ngOnInit() {
    console.log(this.params, this.tableData)
    this.serv.datiGrafico(this.params.mkt,this.params.timeframe, this.tableData[0].ora,this.tableData[this.tableData.length-1].oraclose).subscribe((data: any) => {
      console.log(data)
      if(data.res=='ok'){
        this.caricaGrafico(data.data)
      }else{
        alert('Errore caricamento dei dati')
      }
      
    })
  }

  caricaGrafico(data: any){
    let s1 = data.map((el: any) => [el.ora, parseFloat(el.vclose)])
    let s2 = data.map((el: any) => [el.ora, parseFloat(el.diff)])
    this.chartOptions = {
      title: {
        text: 'Backtest '+this.params.mkt
      },
      chart: {
        zooming: {
          type: 'x'
        }
      },
      series: [{
        name: this.params.mkt,
        data: s1,
        type: 'line',
        color: 'lime',
      },{
        name: 'Crosstrend',
        data: s2,
        type: 'line',
        color: 'orange',
        yAxis: 1
      } ],
      /* xAxis: {
        type: 'datetime',
        labels: {
          format: '{value:%H:%M}'
        }
      }, */
      yAxis: [
        {
          title: {
            text: 'Cambio'
          },
          opposite: true
        },
        {
          title: {
            text: 'Cross'
          }
        }
      ],
      
    }
  }
}
